import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as myStore from '../store/myStore';

function getConversationsReducer() {
  return myStore.getStore().getState().conversationsReducer;
}

export default function messageSummaryReducer(state = initialState.messageSummary, action) {
  switch (action.type) {
    case types.UPDATE_UNREAD_MESSAGE_ALL_SUCCESS:
      return state.set('totalUnread', action.data);
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.messageSummary;
      return state;
    }
    default:
      return state;
  }
}
